import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { NgxEchartsModule } from 'ngx-echarts';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-safety-chart',
  standalone: true,
  imports: [CommonModule, IonicModule, NgxEchartsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div *ngIf="chartOptions" class="safety-chart-wrapper">
      <section *ngIf="description" class="border-1 fx-row fx-align-content-start fx-gap-3 p-1 radius-4 border-accent bg-accent-100 w-full">
        <ion-icon name="information-circle-outline" class="text-accent s-6 min-s-6"></ion-icon>
        <p class="fx-g-1 tw-text-sm tw-font-normal text-normal-wrap" style="color: var(--accent)">{{ description }}</p>
      </section>
      <div class="safety-chart-canvas" echarts [options]="chartOptions"></div>
      <div *ngIf="legend?.length" class="safety-chart-legend">
        <span *ngFor="let item of legend" class="safety-chart-legend-item">
          <span class="safety-chart-legend-dot" [style.background]="item.color"></span>
          {{ item.label }}
        </span>
      </div>
    </div>
  `,
  styles: [`
    .safety-chart-wrapper {
      margin-top: 12px;
      padding-top: 8px;
    }
    .safety-chart-canvas {
      width: 100%;
      height: 280px;
    }
    .safety-chart-legend {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      padding: 8px 16px;
    }
    .safety-chart-legend-item {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      font-family: Inter, system-ui, sans-serif;
      font-weight: 500;
      color: var(--grey-400, #576065);
    }
    .safety-chart-legend-dot {
      width: 12px;
      height: 12px;
      min-width: 12px;
      border-radius: 3px;
    }
  `],
})
export class SafetyChartComponent {
  @Input() chartOptions: EChartsOption | null = null;
  @Input() description?: string;
  @Input() legend?: { color: string; label: string }[];
}
